import React, { useContext, useEffect, useState } from "react";
import Close from "../../../../../../images/Close.svg";
import {
  getItemDetailsByNode,
  getRetireItemDetailsByNode,
} from "../../../masters/items/queries/queries";
import {
  nodeVar,
  OrderDirection,
} from "../../../../../../utils/commonQueryTypes";
import { AtsStckItemDetails } from "../../../masters/items/queries/types";
import { useLazyQuery } from "@apollo/client";

import { Title } from "../../../../../../stories/Title/Title";
import useLabels from "../../../../../../customHooks/useLabels";
import { Button } from "../../../../../../stories/Button/Button";
import {
  convertToTimeZone,
  CustomModal,
  toInputStandardDate,
} from "../../../../../../utils/UtilFunctions";
import { GetTicketsResult, GetTicketsVariables } from "../../queries/types";
import { GetTicketForLatestTicketDetail } from "../../queries/queriers";
import {
  DEFAULT_TIME,
  EMPTY_STRING,
  ROWS_PER_PAGE,
} from "../../../../../../utils/constants";
import {
  AtsTicketsOrderField,
  TicketsQueryType,
} from "../../../../../../queries/types";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import { AppContext } from "../../../../../../context/context";
import { getDownloadUrl } from "../../../../../../utils/DownloadFile";
import { imagePathType } from "../history/FollowUpstatus";
import { TicketDetails } from "./AssetDetails";
import Download from "../../../../../../images/DocumentsDownload.svg";
import {
  ViewItemsModalStyles,
  ViewTicketModalStyles,
} from "../../../../../../styles/CustomModalStyles";
import useServerDateandTime from "../../../../../../customHooks/useServerDateandTime";
import { TimeZone } from "../../../../../../utils/Enum.types";
import { IObjectKeys } from "../../../../../../utils/formTypes";
import RaisedTicketDetails from "../junctionDetails/raisedTickets/RaisedTicketDetails";
import { TableType } from "../../../../customer/companies/queries/types";
import { MapsContext } from "../../context/context";
import { mapsPayloadType } from "../../context/reducer";
import ViewImage from "../../../../../.../../../images/EyeWhite.svg";
import { StateTypes } from "../../Maps";
import { AssetDetailsPageFor } from "../junctionDetails/raisedTickets/AssetDetails";
import { AtsStckRetireItemDetails } from "../../../DashBoardMapsView/dashboardcomponents/types";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  itemId: number;
  itemRetireId?: number;
}

const initialAssetDetails = {
  description: "",
  code: "",
  gstApplicable: "",
  category: "",
  subCategory: "",
  maintainedBy: "",
  uom: "",
  model: "",
  zone: "",
  siteLocation: "",
  prodSerialNo: "",
  prodBatchNo: "",
  prodExpiryDate: "",
  prodWarrantyStartDate: "",
  prodWarrantyEndDate: "",
  prodLatitude: "",
  prodLongitude: "",
  prodInstallationEndDate: "",
  trackSerial: false,
  trackBatch: false,
  trackExpiry: false,
  trackWarranty: false,
  trackGeoLocation: false,
  trackInstallation: false,
};

interface TicketDetailsInterface extends IObjectKeys {
  ticketNo: string;
  assetStatus: string;
  reportedDateAndTime: string;
  ticketReason: string;
  assignee: string;
  priority: string;
  ticketRemarks: string;
  attachments: string;
  aging?: string;
}

const ViewAssetDetails = ({ setModalFlag, itemId, itemRetireId }: Props) => {
  const { customer_id, company_id } = useUrlParams();
  const [ticketDetails, setTicketDetails] = useState<StateTypes>({
    flag: false,
    itemId: 0,
    tableLevel: TableType.COMPANY,
  });
  const [viewHistory, setViewHistory] = useState(false);
  const [assetDetail, setAssetDetail] = useState(initialAssetDetails);
  const { state } = useContext(AppContext);
  const { dispatch } = useContext(MapsContext);
  const [formData, setFormData] = useState<TicketDetailsInterface>({
    ticketNo: "",
    assetStatus: "",
    reportedDateAndTime: "",
    ticketReason: "",
    assignee: "",
    priority: "",
    ticketRemarks: "",
    attachments: "",
  });
  const [imageString, setImageString] = useState("");

  const { serverDate, data, loading } = useServerDateandTime();

  const [GetItemDetails] = useLazyQuery<{ node: AtsStckItemDetails }, nodeVar>(
    getItemDetailsByNode
  );

  const [GetRetireItemDetails] = useLazyQuery<
    { node: AtsStckRetireItemDetails },
    nodeVar
  >(getRetireItemDetailsByNode);

  useEffect(() => {
    if (itemId) {
      GetItemDetails({
        variables: {
          id: itemId,
        },
      }).then(({ data }) => {
        if (data && data.node) {
          const itemData = data.node;
          setAssetDetail({
            description: itemData.item.desc,
            code: itemData.item.code,
            gstApplicable: "",
            category: itemData.item.categoryDetails.categoryName,
            subCategory: itemData.item.subCategoryDetails.subCategoryName,
            maintainedBy: itemData.vendorDetails.desc,
            uom: itemData.item.uom,
            model: itemData.prodModel,
            zone: itemData.currentSite.name,
            siteLocation: `${itemData.prodLatitude},${itemData.prodLongitude}`,

            prodSerialNo: itemData.prodSerialNo,
            prodBatchNo: itemData.prodBatchNo,
            prodExpiryDate: toInputStandardDate(itemData.prodExpiryDate),
            prodWarrantyStartDate: toInputStandardDate(
              itemData.prodWarrantyStartDate
            ),
            prodWarrantyEndDate: toInputStandardDate(
              itemData.prodWarrantyEndDate
            ),
            prodLatitude: itemData.prodLatitude,
            prodLongitude: itemData.prodLongitude,
            prodInstallationEndDate: toInputStandardDate(
              itemData.prodInstallationEndDate
            ),

            trackSerial: itemData.item.trackSerial,
            trackBatch: itemData.item.trackBatch,
            trackExpiry: itemData.item.trackExpiry,
            trackWarranty: itemData.item.trackWarranty,
            trackGeoLocation: itemData.item.trackGeoLocation,
            trackInstallation: itemData.item.trackInstallation,
          });
        }
      });
    }
  }, [itemId, GetItemDetails]);

  useEffect(() => {
    if (itemRetireId) {
      GetRetireItemDetails({
        variables: {
          id: itemRetireId,
        },
      }).then(({ data }) => {
        if (data && data.node) {
          const itemData = data.node;
          setAssetDetail({
            description: itemData.item.desc,
            code: itemData.item.code,
            gstApplicable: "",
            category: itemData.item.categoryDetails.categoryName,
            subCategory: itemData.item.subCategoryDetails.subCategoryName,
            maintainedBy: "-",
            uom: itemData.item.uom,
            model: itemData.prodModel,
            zone: "-",
            siteLocation: `${itemData.prodLatitude},${itemData.prodLongitude}`,

            prodSerialNo: itemData.prodSerialNo,
            prodBatchNo: itemData.prodBatchNo,
            prodExpiryDate: toInputStandardDate(itemData.prodExpiryDate),
            prodWarrantyStartDate: toInputStandardDate(
              itemData.prodWarrantyStartDate
            ),
            prodWarrantyEndDate: toInputStandardDate(
              itemData.prodWarrantyEndDate
            ),
            prodLatitude: itemData.prodLatitude,
            prodLongitude: itemData.prodLongitude,
            prodInstallationEndDate: toInputStandardDate(
              itemData.prodInstallationEndDate
            ),

            trackSerial: itemData.item.trackSerial,
            trackBatch: itemData.item.trackBatch,
            trackExpiry: itemData.item.trackExpiry,
            trackWarranty: itemData.item.trackWarranty,
            trackGeoLocation: itemData.item.trackGeoLocation,
            trackInstallation: itemData.item.trackInstallation,
          });
        }
      });
    }
  }, [GetRetireItemDetails, itemRetireId]);

  const { itemLabel } = useLabels();

  const getAging = (date: string) => {
    if (data && !loading) {
      const presentDate = new Date(serverDate);
      const ticketDate = new Date(date);

      const diffMs = Math.abs(ticketDate.getTime() - presentDate.getTime()); // Absolute difference in ms

      const diffSec = Math.floor(diffMs / 1000); // Total seconds
      const diffMin = Math.floor(diffSec / 60); // Total minutes
      const diffHours = Math.floor(diffMin / 60); // Total hours
      const diffDays = Math.floor(diffHours / 24); // Total days

      const remainingHours = diffHours % 24; // Hours excluding full days
      const remainingMinutes = diffMin % 60; // Minutes excluding full hours
      const remainingSeconds = diffSec % 60; // Seconds excluding full minutes

      let result = "";
      if (diffDays) result += `${diffDays} days `;
      if (remainingHours) result += `${remainingHours} hrs `;
      if (remainingMinutes) result += `${remainingMinutes} mins `;
      if (remainingSeconds) result += `${remainingSeconds} secs`;

      return result.trim(); // Remove extra spaces
    }
    return "";
  };

  const [GetTicketDetail, { data: ticketDetailData }] = useLazyQuery<
    GetTicketsResult,
    GetTicketsVariables
  >(GetTicketForLatestTicketDetail);

  useEffect(() => {
    if (customer_id) {
      GetTicketDetail({
        variables: {
          after: null,
          first: ROWS_PER_PAGE,
          orderBy: {
            direction: OrderDirection.DESC,
            field: AtsTicketsOrderField.CREATED_AT,
          },

          companyID: company_id ? company_id : 0,
          customerID: customer_id,
          subsidiaryID: 0,
          input: {
            itemID: 0,
            ldgrID: 0,
            stckCategoryID: 0,
            stckGroupID: 0,
            stckManufacturerID: 0,
            stckSubCategoryID: 0,
            stckUomID: 0,
            query_type: TicketsQueryType.ALL,
            itemDetailsID: itemId,
            status: [],
            priority: [],
            // empID: user_details.id,
            empID: 0,
          },
          siteID: 0,
        },
      }).then(({ data }) => {
        if (data && data.GetTickets.edges.length) {
          const firstElement = data.GetTickets.edges[0].node;
          setFormData({
            assetStatus: firstElement.status,
            assignee: firstElement.loggedUser.name,
            attachments: firstElement.orderedDetails[0].imagesPath,
            priority: firstElement.priority,
            reportedDateAndTime: convertToTimeZone(
              TimeZone.Asia_Kolkata,
              firstElement.ticketDate
            ).timeAndDate,
            ticketNo: firstElement.ticketNo,
            ticketReason: firstElement.reason,
            ticketRemarks: firstElement.lastRemarks,
            aging: getAging(firstElement.ticketDate),
          });
          const ers = getDownloadUrl(
            firstElement.orderedDetails[0].imagesPath,
            false,
            setImageString
          )
            .then((data) => {
              console.log("data");
            })
            .catch((err) => {
              console.error(err);
            });
        }
      });
    }
  }, [
    GetTicketDetail,
    ticketDetailData,
    company_id,
    customer_id,
    ticketDetailData,
    itemId,
  ]);

  useEffect(() => {
    if (ticketDetailData && ticketDetailData.GetTickets.edges.length) {
      const firstElement = ticketDetailData.GetTickets.edges[0].node;
      if (
        firstElement &&
        firstElement.orderedDetails.length &&
        firstElement.orderedDetails[0].imagesPath
      ) {
        const ext = firstElement.orderedDetails[0].imagesPath.split(".").pop();

        const fileName = `${firstElement.orderedDetails[0].companyID}/ticketDetails/${firstElement.orderedDetails[0].id}_0.${ext}`;
        try {
          const ers = getDownloadUrl(fileName, false)
            .then((data) => {
              console.log("data");
            })
            .catch((err) => {
              console.error(err);
            });
        } catch (err) {
          console.error(err);
        }
      }
    }
  }, [ticketDetailData]);

  return (
    <div className="asset-info">
      <div className="asset-info__title">
        <Title>{itemLabel}</Title>
        <img src={Close} alt="" onClick={() => setModalFlag(false)} />
      </div>

      <div className="asset-info__block">
        <b>Asset Details</b>
        <ul>
          <li>
            <span>Description</span> <span>:</span>
            <b>{assetDetail.description}</b>
          </li>
          <li>
            <span>Code</span> <span>:</span> <b>{assetDetail.code}</b>
          </li>
          <li>
            <span>GST Applicable</span> <span>:</span>
            <b>{assetDetail.gstApplicable}</b>
          </li>
          <li>
            <span>Category</span> <span>:</span> <b>{assetDetail.category}</b>
          </li>
          <li>
            <span>Sub Category</span> <span>:</span>{" "}
            <b>{assetDetail.subCategory}</b>
          </li>
          <li>
            <span>Maintained By</span> <span>:</span>{" "}
            <b>{assetDetail.maintainedBy}</b>
          </li>
          <li>
            <span>UOM</span> <span>:</span> <b>{assetDetail.uom}</b>
          </li>
          <li>
            <span>Model</span> <span>:</span> <b>{assetDetail.model}</b>
          </li>
          <li>
            <span>Zone</span> <span>:</span> <b>{assetDetail.zone}</b>
          </li>
          <li>
            <span>Geo Location</span> <span>:</span>{" "}
            <b>{assetDetail.siteLocation}</b>
          </li>
        </ul>
        <hr className="solid" />

        <br />

        {ticketDetailData && ticketDetailData.GetTickets.edges.length ? (
          <>
            <div className="raised-ticket-details__data--t-details--flex">
              <b className="font-green">Ticket Details</b>
              <button
                onClick={() => {
                  dispatch({
                    type: mapsPayloadType.ITEM_DETAILS_ID,
                    payload: {
                      itemDetailsId: itemId,
                    },
                  });

                  setTicketDetails({
                    flag: true,
                    itemId: state.itemDetailsId,
                    tableLevel: TableType.ASSET,
                  });
                }}
                className="raised-ticket-details__data--t-details--view-button"
              >
                View Details <img src={ViewImage} alt="" />
              </button>
            </div>

            {/* <ul>
              {TicketDetails.map((res, index) => {
                return (
                  <li key={index}>
                    <label>{res.name}</label>
                    <span>:</span>
                    <div>
                      {Array.isArray(res.value) ? (
                        res.value.map((label: any, idx: number) => (
                          <div key={idx}>
                            <b>{label.date || label.name}</b>
                            {label.time && (
                              <span className="font-grey">{label.time}</span>
                            )}
                            {label.desn && (
                              <span className="font-blue">({label.desn})</span>
                            )}
                            {label.Mobile_number && (
                              <span className="font-grey">
                                {label.Mobile_number}
                              </span>
                            )}
                            <div className=" raised-ticket-details__data--attachments">
                              <span>Download</span>{" "}
                              <img src={Download} alt="" />
                            </div>
                          </div>
                        ))
                      ) : res.inputName === "aging" ? (
                        getAging(formData.reportedDateAndTime as string)
                      ) : (
                        <b className={res.className}>
                          {res.name === "Attachments" ? (
                            imageString ? (
                              <img
                                src={imageString}
                                alt=""
                                className="raise-ticket-image"
                              />
                            ) : null
                          ) : (
                            (formData[res.inputName] as unknown as string)
                          )}
                        </b>
                      )}
                    </div>
                    <img src={res.image} alt="" />
                  </li>
                );
              })}
            </ul> */}
          </>
        ) : (
          <>
            {/* <b className="font-green">No Tickets</b> */}
            {/* <button
              className="raised-ticket-details__data--t-details--view-history"
              onClick={() => setViewHistory(!viewHistory)}
            >
              View History
            </button> */}
          </>
        )}

        <hr className="solid" />
        <b>Configure Details</b>
        <ul>
          {assetDetail.trackSerial ? (
            <li>
              <span>Serial No</span> <span>:</span>
              <b>{assetDetail.prodSerialNo}</b>
            </li>
          ) : (
            ""
          )}
          {assetDetail.trackBatch ? (
            <li>
              <span>Batch</span> <span>:</span>
              <b>{assetDetail.prodBatchNo}</b>
            </li>
          ) : (
            ""
          )}
          {assetDetail.trackWarranty ? (
            <>
              <li>
                <span>Warranty Start Date</span> <span>:</span>
                <b>{assetDetail.prodWarrantyStartDate}</b>
              </li>
              <li>
                <span>Warranty End Date</span> <span>:</span>
                <b>{assetDetail.prodWarrantyEndDate}</b>
              </li>
            </>
          ) : (
            ""
          )}
          {assetDetail.trackGeoLocation ? (
            <li>
              <span>Geo Location</span> <span>:</span>
              <b>{assetDetail.siteLocation}</b>
            </li>
          ) : (
            ""
          )}
         
          {assetDetail.trackInstallation ? (
            <li>
              <span>Installation Date Time</span> <span>:</span>
              <b>
                {toInputStandardDate(assetDetail.prodInstallationEndDate) !==
                DEFAULT_TIME
                  ? toInputStandardDate(assetDetail.prodInstallationEndDate)
                  : "-"}
              </b>
            </li>
          ) : (
            ""
          )}
        </ul>
      </div>
      <Button mode="cancel" onClick={() => setModalFlag(false)} />
      <CustomModal
        style={ViewItemsModalStyles}
        isOpen={ticketDetails.flag}
        onRequestClose={() =>
          setTicketDetails({
            flag: false,
            itemId: 0,
            tableLevel: TableType.COMPANY,
          })
        }
        contentComponent={
          <RaisedTicketDetails
            setModalFlag={setTicketDetails}
            assetType={TableType.ASSET}
            pageFor={AssetDetailsPageFor.MAPS}
            itemsView={true}
          />
        }
      />
    </div>
  );
};

export default ViewAssetDetails;
